const visileColumnsJobOrder = [
  // {
  //   title: "Social Security Number",
  //   field: "ssn",
  //   locked: false,
  //   filter: "text",
  //   width: 150,
  //   show: true,
  // },
  {
    title: "Job Number",
    field: "Job_Number",
    locked: false,
    filter: "text",
    width: 170,
    show: true,
  },
  {
    title: "Main Account",
    field: "D365_Account_No",
    locked: false,
    filter: "text",
    width: 230,
    show: true,
  },
  {
    title: "Account Description",
    field: "Description",
    locked: false,
    filter: "text",
    width: 270,
    show: true,
  },
  {
    title: "Description",
    field: "Main_Account_Description",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "AS400 Account No",
    field: "AS400_Account_No",
    locked: false,
    filter: "text",
    // className: "text-end",
    // headerClassName: "number-align",
    // customFilterType: "CustomNumericText",
    width: 210,
    show: true,
    // editor: "numeric",
  },

  // {
  //   title: "D365 Account No",
  //   field: "D365_Account_No",
  //   locked: false,
  //   filter: "text",
  //   width: 250,
  //   show: true,
  // },
  {
    title: "Fund Dimension",
    field: "Fund_Dimension",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  

  
  {
    title: "Year Dimension",
    field: "Year_Dimension",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  
  // {
  //   title: "Main Account",
  //   field: "Main_Account",
  //   locked: false,
  //   filter: "text",
  //   width: 180,
  //   show: true,
  // },
  
];

export default visileColumnsJobOrder;
